if (!customElements.get("overflow-scroll-controls")) {
	customElements.define(
		"overflow-scroll-controls",
		class OverflowScrollControls extends HTMLElement {
			constructor() {
				super();

				this.target = document.getElementById(this.dataset.targetId);
				if (!this.target) return;

				this.controls = this.querySelectorAll(".controls--item");
				this.controls.forEach((control) => this.handleAction(control));
			}

			handleAction(control) {
				control.addEventListener("click", () => {
					const direction = control.dataset.direction;
					const amount = direction === "left" ? -100 : 100;

					this.target.scrollBy({ left: amount, behavior: "smooth" });
				});
			}
		},
	);
}
